import { useState } from "react";
import { Box, Typography, Container, Paper, Grid } from "@mui/material";
import GrievanceDashboard from "./GrievanceDashboard.jsx";
import MPLadsDashboard from "./MPLadsDashboard.jsx";

const Dashboard = () => {
  const [selectedDashboard, setSelectedDashboard] = useState("grievance");

  return (
    <div>
      {/* Header */}
      {/* <Paper
        elevation={3}
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      > */}
        {/* <Typography variant="h6" fontWeight={600}>
          {selectedDashboard === "grievance" ? "Grievance Dashboard" : "MP LADS Dashboard"}
        </Typography>

        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body1">Grievance</Typography>
          <label className="inline-flex relative items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={selectedDashboard === "mp"}
              onChange={(e) =>
                setSelectedDashboard(e.target.checked ? "mp" : "grievance")
              }
            />
            <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 dark:peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 relative"></div>
          </label>
          <Typography variant="body1">MP LADS</Typography>
        </Box> */}
      {/* </Paper> */}

      {/* Content */}
      <Box mt={1}>
        {selectedDashboard === "grievance" ? (
          <GrievanceDashboard />
        ) : (
          <MPLadsDashboard />
        )}
      </Box>
      </div>
  );
};

export default Dashboard;
